import React, { useState, useEffect } from "react";
import Sidebar from "../../../components/AdminComponents/SideNav";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav";
import {
  ClientMenu,
  SecondaryNavModule,
} from "../../../components/AdminComponents/MenuItems";

import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Spin } from "antd";
import { Table, Switch, Divider, Tooltip } from "antd";
import Axios from "../../../api/Axios";
import { message } from "antd";
import { setModuleAccessData } from "../../../store/slices/moduleAccessData";
import { useDispatch } from "react-redux";
import { getUpdateStatus1 } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import DetailsContainer from "../../../components/DetailsContainer";
const ModuleNewAccess = () => {
  // eslint-disable-next-line no-unused-vars
  const [dataSource, setDataSource] = useState();
  const dispatch = useDispatch();
  const history = useNavigate();
  const [displayData, setDisplayData] = useState();
  //console.log(dataSource);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus1(userInfo, 1, 0);
  // eslint-disable-next-line no-unused-vars
  const handleEditClick = () => {
    switch (parseInt(id)) {
      case 1:
        history(`/admin-manager/modules/access/${id}/tl-dashboard-edit`);
        break;
      case 2:
        history(`/admin-manager/modules/access/${id}/tc-dashboard-edit`);
        break;
      case 3:
        history(`/admin-manager/modules/access/${id}/dhr-knowledge-edit`);
        break;
      case 4:
        //console.log("not implemented");
        break;
      default:
        //console.log(id);
        break;
    }
  };
  const otherElementsHeight = 35; // Height of other elements in rem

  // Calculate the remaining viewport height
  const remToPixels = 10; // 1 rem is equal to 10 pixels (already converted)
  const otherElementsHeightInPixels = otherElementsHeight * remToPixels;
  const windowHeight = window.innerHeight;
  const remainingViewportHeight = windowHeight - otherElementsHeightInPixels;
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await Axios.get(`/access/${id}/`);
      const data2 = response.data;
      dispatch(setModuleAccessData(response.data));
      // Creating the desired data array
      const data = [];

      // Create objects based on top_menu items
      data2.forEach((dataItem) => {
        dataItem.top_menu.forEach((item, index) => {
          data.push({
            id: `${dataItem.id}_${index}`,
            name: index === 0 ? dataItem.name : " ",
            top_menu: [item],
          });
        });
      });

      //console.log("setDataSource", data);
      setDataSource(data);
      setAccessData(
        data?.flatMap((item) =>
          item.top_menu.flatMap((menu) =>
            menu.sub_menu.flatMap((subMenu) => subMenu.role_access)
          )
        )
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [messageApi, contextHolder] = message.useMessage();
  const [accessData, setAccessData] = useState();
  const UpdateSuccessfull = () => {
    fetchData();
    messageApi.open({
      type: "success",
      content: "Updated successfully.",
      duration: 5,
    });
  };

  const UpdateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Details have not been updated.",
      duration: 5,
    });
  };
  //console.log(accessData);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleSwitchChangeEdit = async (accessId, field) => {
    try {
      const updatedAccessData = accessData?.map((access) => {
        if (access.id === accessId) {
          return {
            ...access,
            [field]: !access[field],
          };
        }
        return access;
      });

      setAccessData(updatedAccessData);

      const payload = {
        view: updatedAccessData.find((access) => access.id === accessId)?.view,
      };

      await Axios.put(`/roleaccess/${parseInt(accessId)}/`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      UpdateSuccessfull();
    } catch (err) {
      //console.log(err);
      UpdateFailed();
    }
  };
  const handleSwitchChangeUpdate = async (accessId, field) => {
    try {
      const updatedAccessData = accessData?.map((access) => {
        if (access.id === accessId) {
          return {
            ...access,
            [field]: !access[field],
          };
        }
        return access;
      });

      setAccessData(updatedAccessData);

      const payload = {
        update: updatedAccessData.find((access) => access.id === accessId)
          ?.update,
      };

      await Axios.put(`/roleaccess/${parseInt(accessId)}/`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      UpdateSuccessfull();
    } catch (err) {
      //console.log(err);
      UpdateFailed();
    }
  };
  let topMenu;

  if (dataSource && dataSource.length >= 3) {
    topMenu = dataSource[2].top_menu;
  } else {
    topMenu = dataSource?.[0]?.top_menu;
  }
  const roles = [
    ...new Set(
      topMenu?.flatMap((menu) =>
        menu.sub_menu.flatMap((subMenu) =>
          subMenu.role_access.map((access) => access.role)
        )
      )
    ),
  ];
  //console.log(roles);

  const columns = [
    {
      title: "Left Menu",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 150,
      render: (text) => <div>{text}</div>,
    },
    {
      title: "Top Menu",
      dataIndex: "top_menu",
      fixed: "left",
      width: 200,
      render: (_, record) => {
        const menuData = record.top_menu;
        return (
          <div>
            {menuData.map((menu) => (
              <div key={menu.id}>{menu.name}</div>
            ))}
          </div>
        );
      },
    },
    {
      title: "Sub Menu",
      dataIndex: "top_menu",
      fixed: "left",
      width: displayData?.name === "DelegateHR" ? 250 : 200,
      render: (_, record) => {
        const menuData = record.top_menu;
        const menuElements = menuData.flatMap((menu, menuIndex) =>
          menu.sub_menu.map((subMenu, subMenuIndex) => (
            <React.Fragment key={subMenu.id}>
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  height: "24px",
                }}
              >
                {subMenu.name}
              </div>
              {(subMenuIndex !== menu.sub_menu.length - 1 ||
                menuIndex !== menuData.length - 1) && (
                <Divider style={{ margin: "4px 0", borderWidth: "2px" }} />
              )}
            </React.Fragment>
          ))
        );

        return <div>{menuElements}</div>;
      },
    },
    ...roles.flatMap((role) => [
      {
        title: role,
        width: 150,
        children: [
          {
            title: "View",
            width: 60,
            render: (_, record) => {
              const switches = record.top_menu.flatMap((menu, menuIndex) =>
                menu.sub_menu.flatMap((subMenu, subMenuIndex) =>
                  subMenu.role_access
                    .filter((access) => access.role === role)
                    .map((access) => (
                      <React.Fragment key={access.id}>
                        <div
                          style={{
                            height: "24px",
                          }}
                        >
                          <Tooltip
                            title={
                              !updateAuth ||
                              !accessData?.find((data) => data.id === access.id)
                                ?.editable
                                ? "Edit Not Allowed"
                                : "Click to Change"
                            }
                            color={
                              !updateAuth ||
                              !accessData?.find((data) => data.id === access.id)
                                ?.editable
                                ? "#f50"
                                : "#87d068"
                            }
                            trigger="hover"
                          >
                            <Switch
                              disabled={
                                !updateAuth ||
                                !accessData?.find(
                                  (data) => data.id === access.id
                                )?.editable
                              }
                              checked={
                                accessData?.find(
                                  (data) => data.id === access.id
                                )?.view
                              }
                              onChange={() =>
                                handleSwitchChangeEdit(access.id, "view")
                              }
                              size="small"
                            />
                          </Tooltip>
                        </div>
                        {(subMenuIndex !== menu.sub_menu.length - 1 ||
                          menuIndex !== record.top_menu.length - 1) && (
                          <Divider
                            style={{ margin: "4px 0", borderWidth: "2px" }}
                          />
                        )}
                      </React.Fragment>
                    ))
                )
              );
              return <div>{switches}</div>;
            },
          },
          {
            title: "Update",
            width: 80,
            render: (_, record) => {
              const switches = record.top_menu.flatMap((menu, menuIndex) =>
                menu.sub_menu.flatMap((subMenu, subMenuIndex) =>
                  subMenu.role_access
                    .filter((access) => access.role === role)
                    .map((access) => (
                      <React.Fragment key={access.id}>
                        <div
                          style={{
                            height: "24px",
                          }}
                        >
                          <Tooltip
                            title={
                              !updateAuth ||
                              !accessData?.find((data) => data.id === access.id)
                                ?.editable
                                ? "Edit Not Allowed"
                                : "Click to Change"
                            }
                            color={
                              !updateAuth ||
                              !accessData?.find((data) => data.id === access.id)
                                ?.editable
                                ? "#f50"
                                : "#87d068"
                            }
                            trigger="hover"
                          >
                            <Switch
                              disabled={
                                !updateAuth ||
                                !accessData?.find(
                                  (data) => data.id === access.id
                                )?.editable
                              }
                              checked={
                                accessData?.find(
                                  (data) => data.id === access.id
                                )?.update
                              }
                              onChange={() =>
                                handleSwitchChangeUpdate(access.id, "update")
                              }
                              size="small"
                            />
                          </Tooltip>
                        </div>
                        {(subMenuIndex !== menu.sub_menu.length - 1 ||
                          menuIndex !== record.top_menu.length - 1) && (
                          <Divider
                            style={{ margin: "4px 0", borderWidth: "2px" }}
                          />
                        )}
                      </React.Fragment>
                    ))
                )
              );
              return <div>{switches}</div>;
            },
          },
        ],
      },
    ]),
  ];
  const LoadUser = async () => {
    try {
      const res = await Axios.get(`/application/${id}/`);
      setDisplayData(res.data);
      //console.log(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const moduleDetails = [
    { label: "Module Name", value: displayData?.name },
    { label: "Module Logo", value: displayData?.logo, isImage: true },
  ];
  return (
    <div>
      <Sidebar props={ClientMenu}>
        {contextHolder}
        <Spin spinning={loading}>
          <SecondaryNav id={parseInt(id)} menuItems={SecondaryNavModule} />
          <div className="form-container-2">
            {/* {updateAuth && (
                <Button
                  type="primary"
                  onClick={handleEditClick}
                  style={{
                    marginLeft: "auto",
                    // background: "#f58029",
                    fontWeight: "600",
                  }}
                  disabled
                >
                  <FormOutlined /> Edit Details
                </Button>
              )} */}
            <DetailsContainer details={moduleDetails} />

            <div style={{ overflowX: "auto" }}>
              <Table
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                bordered
                size="small"
                rowKey="id"
                scroll={{
                  x: 1000,
                  y: `${remainingViewportHeight}px`,
                }}
                className="table-container-2"
                style={{ margin: "1rem" }}
              />
            </div>
          </div>
        </Spin>
      </Sidebar>
    </div>
  );
};

export default ModuleNewAccess;
